export enum ProFormsModalDisplay {
  LIST,
  SUBMISSION,
}
